<script setup lang="ts">
import { ref, watch } from "vue";

interface Props {
  block: any;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  update: [block: any];
}>();

const localBlock = ref(JSON.parse(JSON.stringify(props.block)));

// Estilos padrão se não existirem
if (!localBlock.value.style) {
  localBlock.value.style = {
    fontSize: "14px",
    lineHeight: "1.6",
    textAlign: "left",
    color: "#000000",
    fontWeight: "normal",
    fontStyle: "normal",
  };
}

watch(
  () => props.block,
  (newBlock) => {
    localBlock.value = JSON.parse(JSON.stringify(newBlock));
  },
  { deep: true }
);

function onChange() {
  emit("update", localBlock.value);
}
</script>

<template>
  <div class="text-edit">
    <h4>Editar Texto</h4>

    <div class="form-group">
      <label>Conteúdo:</label>
      <textarea
        v-model="localBlock.data.content"
        @input="onChange"
        rows="6"
        class="text-content"
        placeholder="Digite o conteúdo do texto..."
      ></textarea>
    </div>

    <div class="form-group">
      <label>Tamanho da Fonte:</label>
      <select v-model="localBlock.style.fontSize" @change="onChange">
        <option value="12px">Pequeno (12px)</option>
        <option value="14px">Normal (14px)</option>
        <option value="16px">Médio (16px)</option>
        <option value="18px">Grande (18px)</option>
        <option value="20px">Muito Grande (20px)</option>
      </select>
    </div>

    <div class="form-group">
      <label>Espaçamento entre Linhas:</label>
      <select v-model="localBlock.style.lineHeight" @change="onChange">
        <option value="1.2">Compacto (1.2)</option>
        <option value="1.4">Normal (1.4)</option>
        <option value="1.6">Confortável (1.6)</option>
        <option value="1.8">Amplo (1.8)</option>
      </select>
    </div>

    <div class="form-group">
      <label>Alinhamento:</label>
      <select v-model="localBlock.style.textAlign" @change="onChange">
        <option value="left">Esquerda</option>
        <option value="center">Centro</option>
        <option value="right">Direita</option>
        <option value="justify">Justificado</option>
      </select>
    </div>

    <div class="form-group">
      <label>Cor do Texto:</label>
      <input type="color" v-model="localBlock.style.color" @change="onChange" />
    </div>

    <div class="form-group">
      <label>
        <input
          type="checkbox"
          v-model="localBlock.style.fontWeight"
          true-value="bold"
          false-value="normal"
          @change="onChange"
        />
        Texto em Negrito
      </label>
    </div>

    <div class="form-group">
      <label>
        <input
          type="checkbox"
          v-model="localBlock.style.fontStyle"
          true-value="italic"
          false-value="normal"
          @change="onChange"
        />
        Texto em Itálico
      </label>
    </div>
  </div>
</template>

<style scoped>
.text-edit {
  padding: 10px 0;
}

h4 {
  margin: 0 0 15px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
  font-size: 13px;
}

.text-content {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  font-family: inherit;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
}

select,
input[type="color"] {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 8px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
}

input[type="checkbox"] {
  margin-right: 8px;
}
</style>
